export default "__VITE_ASSET__ClhGn80$__"